import styled from '@emotion/styled'
import { V2L1DashboardListHeader, V2L1DashboardListHeaderTitle } from './V2L1DashboardList'
import { DashboardLoadStatus, DashboardLoadItemStatus, DashboardSelection, DashboardSelectionType, isDashboardSelectionMatch, StatusedTodo, statusedWorkItemKey } from '@fusion-advantage/formlib'
import { faDownload } from '@fortawesome/pro-solid-svg-icons'
import { FusionColor } from '../../../../theme/FusionStyle'
import { L1ReasonableButton } from '../../../form/l1/L1Button'
import { V2L2DashboardListItem } from './V2L2DashboardListItem'
import { V2L2DashboardListStatusedContent } from './V2L2DashboardListStatusContent'
import { V2L2TodoListItem } from './V2L2TodoListItem'

const V2L3TodoListRoot = styled.div(({theme}) => ({
	display: 'grid',
	gridTemplateRows: 'max-content 1fr max-content',
	rowGap: '.75rem',
	border: `1px solid ${theme.colors.lines}`,
	borderRadius: theme.borderRadius,
	overflow: 'hidden',
	boxSizing: 'border-box',
}))

const L1TodoListFooter = styled.div(({theme}) => ({
	display: 'flex',
	flexDirection: 'row',
	padding: '.5rem',
	height: '2rem',
	placeContent: 'center',
	backgroundColor: theme.colors.lines,
}))

const ListItems = styled.div({
	margin: '0 1rem 0 1.5rem',
	display: 'grid',
	gridTemplateColumns: 'max-content 1fr',
	alignContent: 'start',
	alignItems: 'center',
	columnGap: '1rem',
	rowGap: '.5rem',
	overflowX: 'hidden',
	overflowY: 'auto',
})

const ListItemIndex = styled.div(({theme}) => ({
	color: theme.colors.lines,
	...theme.fonts.bodyBold,
	fontSize: `${14/16}rem`,
}))

const ListItemContainer = styled.div({
	display: 'contents',
})

interface V2L3TodoListProps {
	status: DashboardLoadStatus
	items: StatusedTodo[]
	selection: DashboardSelection
	onItemClick: (item: DashboardSelectionType.TodaySummary|StatusedTodo) => void
	isAuditor: boolean
	onRetrieveAuditClick: () => void
}

export const V2L3TodoList = ({
	status,
	items,
	selection,
	onItemClick,
	isAuditor,
	onRetrieveAuditClick,
}: V2L3TodoListProps) => {
	return (
		<V2L3TodoListRoot>
			<V2L1DashboardListHeader>
				<V2L1DashboardListHeaderTitle>
					TO DO ({items.length})
				</V2L1DashboardListHeaderTitle>
			</V2L1DashboardListHeader>
			<V2L2DashboardListStatusedContent status={status}>
				<ListItems>
					<ListItemContainer>
						<ListItemIndex>&nbsp;</ListItemIndex>
						<V2L2DashboardListItem
							status={DashboardLoadItemStatus.Ready}
							activeColor={FusionColor.OrangeMain}
							active={(
								selection.type === DashboardSelectionType.TodaySummary
							)}
							title="Summary for Today"
							onClick={() => onItemClick(DashboardSelectionType.TodaySummary)}
						/>
					</ListItemContainer>
					{items.map((statusedItem, idx) => (
						<ListItemContainer key={idx}>
							<ListItemIndex>{idx + 1}</ListItemIndex>
							<V2L2TodoListItem
								statusedItem={statusedItem}
								active={isDashboardSelectionMatch(statusedWorkItemKey(statusedItem), selection)}
								onClick={() => onItemClick(statusedItem)}
							/>
						</ListItemContainer>
					))}
				</ListItems>
			</V2L2DashboardListStatusedContent>
			{isAuditor ? (
				<L1TodoListFooter>
					<L1ReasonableButton
						disabled={status !== DashboardLoadStatus.Ready}
						onClick={onRetrieveAuditClick}
						icon={faDownload}
						label='Retrieve Next Audit'
						color={FusionColor.White}
						wide={true}
					/>
				</L1TodoListFooter>
			) : null}
		</V2L3TodoListRoot>
	)
}
